// @file this vue composable is used for tracking the mouse position across the entire application

import { createSharedComposable, useMouse } from '@vueuse/core'

/**
 * Shared mouse position composable that provides global mouse coordinates.
 * This uses VueUse's useMouse internally but ensures only one instance exists
 * across the entire application via createSharedComposable.
 *
 * Initialize this in SurfaceApp.vue and access coordinates from any component.
 */
const useSharedMouse = createSharedComposable(useMouse)
export { useSharedMouse }
